export enum EResumeActeMode {
	label = "label",
	lettreCle = "lettreCle"
}